import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ConfirmDialogOptions } from './confirm-dialog-options';

@Component({
    imports: [AngularSvgIconModule, MatDialogModule],
    selector: 'rdx-confirmation-dialog',
    styleUrls: ['./confirm-dialog.component.scss'],
    templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
    options: ConfirmDialogOptions;
    playStoreUrl = '';
    appStoreUrl = '';

    constructor(
        private configService: ConfigService,
        @Inject(MAT_DIALOG_DATA) public data?: ConfirmDialogOptions
    ) {
        this.options = data ?? new ConfirmDialogOptions();
        this.playStoreUrl =
            this.options.playStoreUrl || this.configService.appStoreUrl.google;
        this.appStoreUrl =
            this.options.appStoreUrl || this.configService.appStoreUrl.apple;
    }
}
